import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Component } from 'types';

type UpdateComponentData = {
  name?: string;
  description?: string;
  lead?: string;
};

const updateComponent = async (
  componentId: string,
  updateData: UpdateComponentData
): Promise<Component> => {
  const response = await customAxios.patch<Component>(`/components/${componentId}`, updateData);
  return response.data;
};

export const useUpdateComponent = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      componentId,
      updateData,
    }: {
      componentId: string;
      updateData: UpdateComponentData;
    }) => updateComponent(componentId, updateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['components', orgId] }).catch(() => undefined);
    },
  });
};
